var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',{staticClass:"row"},[_c('td',[_vm._v("id")]),_c('td',[_c('a',{attrs:{"href":'/node/edit/' + _vm.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.id))])])]),_vm._l((_vm.entries),function(row){return _c('tr',{key:row[0],staticClass:"row"},[_c('td',[_vm._v(_vm._s(row[0]))]),_c('td',[_vm._v(_vm._s(row[1]))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }